import React, { memo, useMemo } from 'react';
import { View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { CardView, rem, Spacer } from 'design-system';
import { useAppSelector } from 'store/hooks';
import { useDefaultHeaderHeight } from 'hooks/useHeaderHeight';
import { makeSelectTransactionById } from 'features/transactions/selectors';
import TransactionLogo from 'features/transactions/components/TransactionLogo';
import TransactionHeaderText from 'features/transactions/components/detail/TransactionHeaderText';
import { useTransactionHeaderUpgradeButtons } from 'features/transactions/components/detail/TransactionHeader';
import TransactionTopSection from 'features/transactions/components/detail/TransactionTopSection';
import TransactionCategorySection from 'features/transactions/components/detail/TransactionCategorySection';
import { noop } from 'lodash';
import TransactionPendingSection from 'features/transactions/components/detail/TransactionPendingSection';
import TransactionOriginalDateItem from 'features/transactions/components/detail/TransactionOriginalDateItem';
import TransactionTagsItem from 'features/transactions/components/detail/TransactionTagsItem';
import TransactionNotesItem from 'features/transactions/components/detail/TransactionNotesItem';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
const WalkthroughTransactionDetails = ({ id }) => {
    const { top } = useSafeAreaInsets();
    const navHeight = useDefaultHeaderHeight();
    const styles = useStyles(styleSet);
    const memoSelectTransactionById = useMemo(makeSelectTransactionById, []);
    const transaction = useAppSelector((store) => memoSelectTransactionById(store, id));
    const { showFirstUpgradeButton, showRenameUpgradeButton, useCustomName, onPressUpgrade, } = useTransactionHeaderUpgradeButtons(transaction);
    if (!transaction)
        return null;
    return (<View pointerEvents="none">
        <View style={{ height: navHeight, paddingTop: top }}/>
        <CardView noMargin style={styles.mainCard}>
          <Spacer h={8}/>
          <View style={styles.centerAlign}>
            <TransactionLogo border light transaction={transaction} R70/>
          </View>
          <Spacer h={16}/>
          <TransactionHeaderText transaction={transaction} showFirstUpgradeButton={showFirstUpgradeButton} showRenameUpgradeButton={showRenameUpgradeButton} onPressUpgrade={onPressUpgrade} useCustomName={useCustomName}/>
          <Spacer h={16}/>

          <TransactionTopSection transaction={transaction}/>
          <TransactionCategorySection transaction={transaction} onCategoryEdit={noop}/>
          {transaction?.isPending ? (<TransactionPendingSection />) : (<CardView noMargin>
              <TransactionOriginalDateItem transaction={transaction}/>
              <TransactionTagsItem transaction={transaction}/>
              <TransactionNotesItem transaction={transaction}/>
            </CardView>)}
        </CardView>
      </View>);
};
export default memo(WalkthroughTransactionDetails);
const styleSet = createStyleSheets((colors) => ({
    centerAlign: {
        alignItems: 'center',
    },
    mainCard: {
        padding: rem(4),
        marginHorizontal: rem(12),
        backgroundColor: colors.background.dark,
    },
}));
